import { render, staticRenderFns } from "./ViewMarketplaceRevenues.vue?vue&type=template&id=3d9b6c9c&scoped=true&lang=true"
import script from "./ViewMarketplaceRevenues.vue?vue&type=script&lang=js"
export * from "./ViewMarketplaceRevenues.vue?vue&type=script&lang=js"
import style0 from "./ViewMarketplaceRevenues.vue?vue&type=style&index=0&id=3d9b6c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9b6c9c",
  null
  
)

export default component.exports